export default {
  activedWeek: ({ weeks, activedWeekIndex }) => weeks[activedWeekIndex],
  selectedDayIsToday: ({ today, selectedDay }) =>
    selectedDay.isSame(today, 'day'),
};
